import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {getCellBackgroundColor, getCellBoxShadowStyles} from '../helpers/tableCellHelpers';
import {getStickyStyles, getWidthSettingsStyles, TableColumnSettings} from '../tableColumn';

/*
 * Props.
 */

interface MaybeRenderStickyContainerCellProps {
  settings?: TableColumnSettings;
  index: number;
  shouldShowStickyGradient?: boolean;
  shouldAllowMultiSelect?: boolean;
}

/*
 * Styles.
 */

interface StyledStickyContainerDivProps {
  $settings?: TableColumnSettings;
  $index: number;
  $shouldShowStickyGradient: boolean;
}
const StyledStickyContainerDiv = styled.div<StyledStickyContainerDivProps>`
  ${(p) => getCellBackgroundColor()}
  ${(p) => getWidthSettingsStyles(p.$settings?.cellWidth, p.$index)}
  ${(p) =>
    getStickyStyles({
      isSticky: p.$settings?.sticky?.isSticky,
      stickyOffset: p.$settings?.sticky?.stickyOffset,
    })}
  ${(p) => getCellBoxShadowStyles(p.$shouldShowStickyGradient)}
`;

/*
 * Component.
 */

export const MaybeRenderStickyContainerCell: FC<PropsWithChildren<MaybeRenderStickyContainerCellProps>> = (
  props,
) => {
  const {children, settings, index, shouldShowStickyGradient} = props;

  if (!settings || !settings.sticky) {
    return <>{children}</>;
  }
  return (
    <StyledStickyContainerDiv
      $settings={settings}
      $index={index}
      $shouldShowStickyGradient={Boolean(shouldShowStickyGradient)}
    >
      {children}
    </StyledStickyContainerDiv>
  );
};
